import admin from './admin';
import customer from './customer';

const COPY = process.env.NEXT_PUBLIC_ASSEMBLY === 'true' ? admin : customer;

export default COPY;
